import React from 'react';
import {
  Badge, Box, IconName,
} from '@usealloy/component-library';

export default function Footer() {
  return (
    <Box
      style={{ height: '100%', padding: '0px var(--cl-space-6)' }}
      gap={2}
      justifyContent="flex-start"
    >
      <Badge
        icon={IconName.Info}
        outline
        status="info"
      >
        {'Any changes to a tag\'s local settings will impact this Workflow only.'}
      </Badge>

    </Box>

  );
}
